angular
	.module('empower.contactUs')
	.constant('dropdownToShowEnum', {
		NONE: 0,
		POLICY: 1,
		CLAIM: 2
	});